import React from 'react';
import {Company} from '../../hooks/api/utils/types';

const CompanyContext = React.createContext<null|Company>(null);

CompanyContext.displayName = 'CompanyContext';

export default CompanyContext;
